import { useEffect, useState } from "react";
import axios from "../../../../config/axios";
import { showErrorToast } from "../../../../components/Toasts";

const useAccessSystems = () => {
  const [accessSystems, setAccessSystems] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const fetchAccessSystems = () => {
    axios
      .get(`/api/v1/access_systems.json`)
      .then(function (response) {
        setAccessSystems(response.data.entries);
        setLoaded(true);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const archive = (access_system) => {
    axios
      .delete(`/api/v1/access_systems/${access_system.id}.json`)
      .then(function () {
        fetchAccessSystems();
      })
      .catch(function (error) {
        showErrorToast(error.response.data);
      });
  };

  const save = (access_system) => {
    axios
      .delete(`/api/v1/access_systems/${access_system.id}.json`)
      .then(function () {
        fetchAccessSystems();
      })
      .catch(function (error) {
        showErrorToast(error.response.data);
      });
  };

  useEffect(() => {
    fetchAccessSystems();
  }, []);

  return { accessSystems, loaded, fetchAccessSystems, archive, save };
};

export default useAccessSystems;
